import * as React from 'react';

import * as styles from './GalleryLabelsIcon.css';

interface IGalleryLabelsProps {
  iconUrl: string;
}

export const GalleryLabelsIcon = ({ iconUrl }: IGalleryLabelsProps) => {
  return <span className={styles['icon']} style={{ backgroundImage: `url(${iconUrl})` }} />;
};
